import strings from '../../resources/strings';
import { MeetingStatus } from './MeetingsPageInterfaces';

const { meetings } = strings.coachPage;

const availableMonthAmount = 3;

const maxDate = new Date();
maxDate.setMonth(new Date().getMonth() + availableMonthAmount);
const minDate = new Date();
minDate.setFullYear(minDate.getFullYear());

const consts = {
    defaultUILanguage: 'en',
    meetingTypeList: [
        {
            name: { en: 'New' },
            id: MeetingStatus.New,
        },
        {
            name: { en: 'Confirmed' },
            id: MeetingStatus.Confirmed,
        },
        {
            name: { en: 'Cancelled' },
            id: MeetingStatus.Cancelled,
        },
    ],
    status: {
        new: {
            color: 'warning',
            title: meetings.new,
        },
        confirmed: {
            color: 'success',
            title: meetings.confirmed,
        },
        cancelled: {
            color: 'error',
            title: meetings.cancelled,
        },
    },
    timeslot: {
        startTime: 8,
        length: 12,
    },
    maxDate,
    minDate,
    currentDate: new Date(),
};

export default consts;
